<template>
  <div>
    <div class="center text-center pad" v-if="!aux.loaded">
      <div class="pt-5 lds-ripple">
        <div></div>
        <div></div>
      </div>
      <div class="text-center">
        <div class="mt-5">Procesando</div>
      </div>
    </div>
    <div v-else class="pt-5">
      <div
          v-on:mouseup="clikeado=false"
          v-on:touchstart="clikeado=true;lasPoint=$event.changedTouches[0].screenX"
          v-on:touchend="clikeado=false"
          v-on:mousedown="clikeado=true"
          v-on:mousemove="mouse"
          v-on:touchmove="touch"
          class="move text-center animated fadeIn"
      >
        <img :src="imgs[intex].src" alt="360 Car" class="img-fluid" />
      </div>
      <div class="text-center mt-2 text-muted">
        <i class="fa fa-undo" aria-hidden="true" />
        Arrastra para interactuar
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "imagen-360",
  data: () => ({
    auxs: process.env.VUE_APP_URL_API,
    intex: 0,
    nrm: 0,
    lasPoint: 0,
    imgs: [],
    cargadas: [],
    cargado: false,
    cambio: true,
    clikeado: false,
    aux: {
      loaded: false
    },
  }),
  props: ["cargando", "version"],
  watch:{
    imagenes:function(){
      this.aux.loaded=false;
      this.crearCanvas();
    }
  },
  computed:{
    imagenes:function(){
      return this.$store.getters.getPasos[2].color.elements
    }
  },
  methods: {
    mouse({movementX}) {
      this.move(movementX)
    },
    touch(e){
      let touch = e.changedTouches[0];
      let touchDelta = this.lasPoint - touch.screenX;
      this.move(touchDelta);
      this.lasPoint = touch.screenX;
    },
    move(movimientoX) {
      if(this.clikeado){
        if (movimientoX > 0) {
          this.addMovement(+1);
        } else if (movimientoX < 0) {
          this.addMovement(-1);
        }
      }
    },
    addMovement(i){
      this.intex = this.intex + i
      if (this.intex < 0) {
        this.intex = this.imgs.length + this.intex
      } else if (this.intex > this.imgs.length - 1) {
        this.intex = this.intex - this.imgs.length
      }
    },
    loadImgE: function(e) {
      const index = this.imgs.findIndex(i=>i.src===e.target.currentSrc)
      if(index>-1){
        this.$delete(this.imgs, index)
      }
    },
    loadImg: function (img){
        this.nrm++;
        this.imgs.push(img)
        if(this.imagenes.length===this.nrm){
          setTimeout(()=>{
            this.aux.loaded = true
          },2000)
        }
    },
    crearCanvas: function () {
      this.intex = 0;
      this.nrm = 0;
      let aux = null;
      this.imgs = []
      this.imagenes.map(item=>{
          aux = new Image();
          aux.src = process.env.VUE_APP_URL_API+item.dt2;
          aux.onload = this.loadImg(aux)
          aux.onerror = this.loadImgE
      });
    }
  },
  mounted() {
    this.crearCanvas();
  }
}
</script>

<style scoped>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #424242;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}

canvas {
  cursor: pointer;
}

.center {
  margin: auto;
  width: 50%;
  padding: 10px;
}

.pad {
  padding-top: 20%;
  min-height: 300px;
}
.move{
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: ew-resize;
}
</style>
